import { predicateValues } from '../../shared/constants/constants';

// eslint-disable-next-line complexity
export function getFilterValueOption(key, option, isInLabel) {
    return {
        [key]: {
            predicate: {
                textField: isInLabel,
                valueField: predicateValues.isIn,
            },
            values: [option],
        },
    };
}

// eslint-disable-next-line complexity
export function getFilterSelectOption(
    filterKey,
    availableFilters,
    filterValue,
    selectOptions
) {
    const defaultFilter = { textField: filterValue, valueField: filterValue };

    const filter = availableFilters[filterKey];
    if (!filter) {
        return defaultFilter;
    }
    const filterOptions = selectOptions.find(
        (x) => x.fieldName === filter.apiKey
    )?.options;

    if (!filterOptions) {
        return defaultFilter;
    }

    const option = filterOptions.find((x) => x.textField === filterValue);

    return option ?? defaultFilter;
}

export function lightenOrDarkenColor(color, percentage) {
    /* eslint-disable */
    return `#${color
        .slice(1)
        .match(/../g)
        .map((x) =>
            ((x = +`0x${x}` + percentage), x < 0 ? 0 : x > 255 ? 255 : x)
                .toString(16)
                .padStart(2, 0)
        ).join``}`;
    /* eslint-enable */
}
